import Vue from 'vue';
import App from './App';
import router from './router';
import chartSettings from '@/modules/chartSettings';
import shapesNamingLabel from "@/modules/charts/shapesNamingLabel";

Vue.config.productionTip = false;
Vue.prototype.$chartSettings = chartSettings;
Vue.prototype.$shapesNamingLabel = shapesNamingLabel;

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  render: (h) => { return h(App); },
});



// WEBPACK FOOTER //
// ./src/main.js